import icon from 'assets/icons/ArenaLogo.png'

export default function SuspenseLoader() {
  return (
    <div className="loader-overlay">
      <div className="loader-icon">
        <img src={icon} alt="arena logo" />
      </div>
    </div>
  )
}
